<div class="dark-mode">
    <div class="row">
        <div class="col-6 col-sm-6 col-md-6 text-end">
            <div class="d-flex" style="gap: 10px">
                <mat-form-field class="mb-1 w-100" appearance="outline" >
                    <mat-icon matPrefix>search</mat-icon>
                    <input type="text" placeholder="Search" matInput [(ngModel)]="pageQuery.search" (keyup)="searchUser($event)">
                    <mat-icon (click)="clearSearch()" *ngIf="showCloseSearch && pageQuery.search.length > 0" class="button-flat" matSuffix>close</mat-icon>
                </mat-form-field>
            </div>

        </div>
    </div>

    <div class="table-responsive-dark list-wrapper-bordered-dark">
        <table class="table table-striped table-hover table-bordered ">
            <thead>
            <tr>
                <th class="text-nowrap text-end"></th>
                <th class="text-nowrap">Domain Name</th>
                <th class="text-nowrap">Target Objectives</th>
                <th class="sticky-action"></th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngIf="domains.length > 0">
                <ng-container *ngFor="let domain of domains">
                    <ng-container *ngFor="let objective of domain.objectives; let i = index">
                        <tr>
                            <!-- Column 1: ID -->
                            <td *ngIf="i === 0"
                                [attr.rowspan]="domain.objectives.length"
                                class="text-center"
                                style="vertical-align: top;">
                                <mat-icon [matTooltip]="'Add more target objective'" class="mr-2 crimson-red button-flat" (click)="addNewObjective(domain.id)">add</mat-icon>
                            </td>

                            <!-- Column 2: Domain Name -->
                            <td *ngIf="i === 0"
                                [attr.rowspan]="domain.objectives.length"
                                class="text-start"
                                style="vertical-align: top;">
                                {{ domain.domainName }}
                            </td>

                            <!-- Column 3: Objective Name -->
                            <td class="text-start">
                                {{ objective.objectiveName }}
                            </td>

                            <!-- Column 4: Actions -->
                            <td class="text-center p-1 action-column" style="width: 140px; vertical-align: top;">
                                <div class="d-flex gap-3 justify-content-center">
                                    <mat-icon [matTooltip]="'view activity'" class="text-white mr-2" (click)="detailObjective(domain.id, objective.id)">arrow_forward</mat-icon>
                                    <mat-icon [matTooltip]="'Edit activity'" class="mr-2 accent-orange" (click)="editObjective(domain.id, objective.id)">edit</mat-icon>
                                    <mat-icon [matTooltip]="'Delete activity'" class="crimson-red" (click)="deleteObjective(domain.id, objective.id)">delete</mat-icon>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </ng-container>

            <tr *ngIf="domains.length == 0">
                <td colspan="4" class="text-center">
                    <span>{{tableLoading ? 'Load data...' : 'No Record'}}</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="mt-4" *ngIf="domains.length > 0">
        <app-pagination-dark
                (goPage)="toPage($event)"
                (goPerPage)="perPageSet($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [count]="totalRow"></app-pagination-dark>
    </div>
</div>

